import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation, Navigate, Outlet } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import type { Locale } from '../i18n/translations';

const LocaleFromUrl: React.FC = () => {
  const { locale: urlLocale } = useParams<{ locale: string }>();
  const { setLocale } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (urlLocale === 'en') {
      const withoutEn = location.pathname.replace(/^\/en/, '') || '/';
      navigate(withoutEn + location.search + location.hash, { replace: true });
      return;
    }
    if (urlLocale === 'da') {
      setLocale('da');
    }
  }, [urlLocale, setLocale, location.pathname, location.search, location.hash, navigate]);

  if (urlLocale === 'en') {
    return null;
  }

  if (urlLocale !== 'da') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default LocaleFromUrl;
